var React = require('react');

function SendInline (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"12.5","cy":"12.3589","rx":"12.5","ry":"12.3589","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.3631 12.8481L18.2173 5.50999L14.7537 19.2077L11.2902 15.7833L8.81622 19.2077L8.32143 14.3157L4.3631 12.8481ZM14.228 17.2815L16.702 7.40566L6.74428 12.6952L9.31101 13.643L15.2485 8.93442L11.2902 14.3157L14.228 17.2815Z","fill":"white","key":1})]);
}

SendInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = SendInline;

SendInline.default = SendInline;
